export default __webpack_public_path__ + "static/media/person.b84df514.svg";